class RFHeader extends HTMLElement {
  connectedCallback() {
    this.desktopMenus = [...this.querySelectorAll('.rf-nav__item--mega')];
    this.mobileMenu = this.querySelector('.rf-mobile-nav');

    this.desktopMenus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        this.desktopMenus.forEach((other) => {
          if (other !== menu) other.open = false;
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (this.contains(event.target)) return;
      this.desktopMenus.forEach((menu) => { menu.open = false; });
    });

    this.querySelectorAll('[data-rf-menu-close]').forEach((control) => {
      control.addEventListener('click', () => this.closeMobileMenu());
    });

    this.mobileMenu?.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('rf-menu-open', this.mobileMenu.open);
    });

    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      this.desktopMenus.forEach((menu) => { menu.open = false; });
      this.closeMobileMenu();
    });
  }

  closeMobileMenu() {
    if (this.mobileMenu) this.mobileMenu.open = false;
  }
}

if (!customElements.get('rf-header')) customElements.define('rf-header', RFHeader);
